var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "rgb(255, 81, 0)",
    strokeWidth: 2,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 14,
    y2: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.dbb1b2d776ce546ffea497d5c1528fd1.svg";
export { ForwardRef as ReactComponent };